var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockRecomended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71371 0 0 6.71371 0 15C0 23.2863 6.71371 30 15 30C23.2863 30 30 23.2863 30 15C30 6.71371 23.2863 0 15 0ZM20.5645 18.9315L19.3548 20.4435C19.1734 20.6855 18.9315 20.8669 18.5685 20.8669C18.3871 20.8669 18.1452 20.746 18.0242 20.625L13.9718 17.6008C13.3669 17.1774 13.0645 16.5121 13.0645 15.7258V6.29032C13.0645 5.80645 13.4879 5.32258 14.0323 5.32258H15.9677C16.4516 5.32258 16.9355 5.80645 16.9355 6.29032V15L20.4435 17.6008C20.625 17.7823 20.8065 18.0242 20.8065 18.3266C20.8065 18.5685 20.6855 18.8105 20.5645 18.9315Z",
    fill: "#575757"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRecomended);
export default __webpack_public_path__ + "static/media/clockRecomended.8e155d44.svg";
export { ForwardRef as ReactComponent };